<template>
    <b-container fluid style="padding-bottom:135px; padding-top:0" class="bg_atos">
        <b-container style="padding-top:80px; margin-bottom:80px">
            <b-row style=" margin-bottom:40px">
                <b-col class="paternTitle">
                    {{$t('faq_title')}}
                </b-col>
            </b-row>
        <fAQ 
                v-for="(faq,i) in faqs" 
                :key="i" 
                :faq="faq" 
                :index="i"
                :icon="faq.open?'remove':'add'"
                :classCss="faq.open?'show':''"
                @toogleOpen="toogleOpen"
        ></fAQ>
    
        </b-container>
    </b-container>
</template>

<script>
import FAQ from '../components/Faq.vue'
import { fail } from 'assert';

export default {
    components:{
        FAQ
    },
    methods:{
        toogleOpen:function(index){
            this.faqs = this.faqs.map((faq, i) =>{
                if(index === i)
                    faq.open = !faq.open;
                else
                    faq.open = false

                return faq;
            })
        }
    },
    data(){
        return{
            faqs:[
                {
                    question:'O que é a Plataforma Atos?',
                    answer:[`A Plataforma Atos é uma ferramenta quer tem como objetivo facilitar o 
                    monitoramento e acompanhamento dos atos normativos do Poder Executivo Federal 
                    (decretos, portarias e instruções normativas) pela sociedade. A partir da leitura do 
                    Diário Oficial da União (DOU), a ferramenta permite, de maneira rápida e fácil, a 
                    comparação entre atos normativos publicados e atos normativos até então vigentes. 
                    Nesta versão, será possível analisar os decretos presidenciais a partir de 2007, e as 
                    portarias e as instruções normativas desde 2017.`],
                    open:false,
                },
                {
                    question:'Quais são as informações disponibilizadas na plataforma Atos?',
                    answer:[`As informações disponibilizadas pela plataforma Atos são coletadas pelo Instituto Igarapé a 
                    partir de leitura do Diário Oficial da União (DOU) e do Portal da Legislação, disponibilizado 
                    pelo Executivo Federal. A atualização da leitura do DOU e do Portal da Legislação é realizada a 
                    cada 2 horas. A partir dessa leitura, a plataforma disponibiliza as informações dos decretos 
                    presidenciais desde 01 de janeiro de 2007, e portarias e instruções normativas  desde 01 de janeiro 
                    de 2017.`,`Caso o ato normativo publicado esteja relacionado a outro ato normativo de período 
                    anterior, este conteúdo também é disponibilizado, com a indicação do que foi 
                    alterado, revogado ou incluído. No caso do Portal da Legislação, as informações 
                    utilizadas são referentes às bases de Decretos e Decretos não numerados.`],
                    open:false,
                    
                },
                {
                    question:'Quais são as principais funcionalidades da ferramenta? Como ela pode me ajudar?',
                    answer:[`A plataforma Atos é uma ferramenta que facilita a identificação de alterações
                     em atos normativos realizadas por outros atos normativos. Por meio de um mecanismo de 
                     busca por número, data e/ou palavra-chave, o Atos permite a visualização de modificações
                      (alteração, inclusão ou revogação) realizadas por determinado ato normativo em outro 
                      ato normativo. Ao selecionar determinado ato normativo, um resumo das modificações é 
                      apresentado. É possível clicar em cada uma dessas modificações e ter acesso ao texto 
                      original do decreto. No caso de alterações no texto, um quadro comparativo com o texto 
                      original e o texto alterado também é disponibilizado. A plataforma permite ao usuário
                       cadastrar palavras-chave para receber alertas sobre atos normativos que possam ser 
                       de seu interesse.`],
                    open:false,
                },
                {
                    question:'Como posso realizar uma busca?',
                    answer:[`Existem três principais formas de busca no Portal Atos: busca por texto, por datas e por tipos de atos normativos (decreto, portaria ou instrução normativa). Na área de busca, é possível digitar o número do ato normativo que pretende encontrar ou alguma palavra, termo ou frase, incluindo trechos de algum dispositivo.
                    Você também pode buscar pelo nome da autoridade responsável pela edição do ato, como a Presidência da República, ou pela data da sua publicação. Se você quiser procurar por temas, é possível buscar por meio de expressões como “meio ambiente”, “segurança pública” ou “direitos humanos”, por exemplo. `,
                    `É possível também indicar o ato normativo exato que se está buscando, por exemplo, “Decreto 123” ou “Portaria 321”. ,
                    Por fim, se você procura por algum termo específico que está inserido no ato normativo, você também pode realizar a busca por ele, por exemplo, escrevendo termos como “exoneração” ou “nomeação” ou, ainda, uma frase completa, como “seleção de membros para ocupar os cargos…”. ,
                    Após digitar a sua opção, aperte na lupa e os resultados aparecerão na aba “atos normativos”.
                    Caso você queira limitar a sua busca a um período determinado, você pode selecionar a data inicial e a data final da sua busca. Se você quer apenas procurar pelos atos normativos publicados em 2021, por exemplo, você deve selecionar o dia 1/01/2021 na data inicial e o dia 31/12/2021 na data final.
                    Você ainda pode buscar por decretos com base no tipo de modificação que ele resultou. Na caixa “tipo de modificação" é possível selecionar apenas os decretos que incluíram, alteraram, revogaram ou não modificaram o texto de outro decreto.`,
                    'image1.png',
                    `image2.png`,
                    
                    `image3.png`],
                    open:false,
                },
                {
                    question:'Como posso analisar/ comparar as alterações normativas?',
                    answer:[`Para facilitar a comparação entre os atos normativos e a análise entre o que está valendo e o que não está mais valendo, disponibilizamos na ferramenta um resumo das modificações.`,
                    `Ao abrir o decreto, você poderá selecionar os artigos que alteraram ou revogaram o texto anterior ou ainda incluíram novo texto. Os que estão em amarelo foram alterados, os que estão em verde foram incluídos e os que estão em vermelho foram revogados.`,
                    `image4.png`,
                    // `Ao clicar nos dispositivos que foram alterados, você poderá avaliar o texto antigo, que não está mais em vigor, e o texto novo, de acordo com o decreto publicado. Ao clicar nos dispositivos que foram incluídos, você verá o que há de novo no decreto publicado e que não havia previsão anteriormente. Ao clicar nos dispositivos que foram revogados, você verá o trecho que não está mais em vigor e não encontra nenhum correspondente no decreto em vigor.`,
                    `image5.png`,
                    `image6.png`,
                    //`Você também pode ver se um decreto realizou alterações, inclusões ou revogações na página inicial, na aba “atos normativos”, no canto direito de cada ato. Quando a cor verde estiver aparecendo, é sinal de que houve inclusões. Se a cor vermelha estiver aparecendo, houve revogações. Se a amarela estiver aparecendo, houve modificações. Pode ser que todas, uma, duas ou nenhuma das cores esteja aparecendo, a depender do conteúdo do decreto.`,
                    `image7.png`],
                    open:false,
                },
                {
                    question:'Consigo visualizar todas as modificações realizadas nos Decretos?',
                    answer:[`Nossa equipe vem trabalhando para identificar todos os padrões de texto das 
                    publicações para identificar essas modificações. Nessa versão beta, as alterações 
                    realizadas nos anexos dos decretos ainda não aparecem disponíveis. Eventuais mudanças 
                    de padrões na publicação ou no intervalo de publicação dos links dos decretos no site 
                    do Planalto também exigem um tempo maior de processamento.`],
                    open:false,
                },
                {
                    question:'Por que a Plataforma Atos foi criada?',
                    answer:[`Considerando o impacto que os atos normativos do Executivo Federal têm nas 
                    políticas públicas que definem os nossos rumos como país e que afetam nossas 
                    vidas nas mais diferentes áreas, é fundamental ampliarmos a capacidade de acompanhamento 
                    desses atos por parte de cidadãos, organizações não-governamentais, jornalistas, pesquisadores, 
                    etc.`,`
                    Esta ampliação da capacidade de controle social sobre os atos de governo permitirá 
                    também uma maior mobilização da sociedade, inclusive para que ela possa questionar 
                    tais atos quando estes ultrapassarem os seus limites legais estabelecidos pela 
                    Constituição.`],
                    open:false,
                },
                
                
                
                
                {
                    question:'Quais informações estão disponíveis na aba “atos normativos”?',
                    answer:[`Na aba “atos normativos” você terá o resultado da sua busca ou o total de atos normativos. Para cada ato publicado, há um retângulo explicitando o tipo do ato (decreto, portaria ou instrução normativa) e o seu número, a data da sua publicação, a descrição do ato, se houver, e, ainda, se o ato realizou alterações, inclusões ou revogações.`,
                    `image8.png`],
                    open:false,
                },
                {
                    question:'Para que serve a busca avançada?',
                    answer:[`Na busca avançada, é possível definir que tipo de busca você deseja realizar. Você pode optar por buscar todas as palavras digitadas, qualquer uma das palavras digitadas ou a frase exata. Caso você não selecione nenhuma dessas opções, você será direcionado para a busca padrão, que irá buscar todas as palavras digitadas.`,
                    `image9.png`],
                    open:false,
                },
                {
                    question:'O que é painel de análise e para que ele serve?',
                    answer:[`O painel de análise é a área em que é disponibilizado um gráfico, onde é possível observar o número de atos normativos editados por ano ou por mês. Você pode verificar o gráfico do número total de atos normativos, inclusive dos totais de decretos, portarias e instruções normativas ou apenas dos atos normativos que correspondem à sua busca ou filtro selecionado. Por exemplo, ao buscar a palavra-chave de sua escolha na aba “atos normativos”, você poderá ver todos os resultados da busca por meio de gráficos ao clicar na aba “painel de análise”. Assim, você poderá analisar os mesmos decretos que apareceram em sua busca, podendo selecionar o período que deseja analisar.`,
                    `image10.png`],
                    open:false,
                },
                {
                    question:'Como faço para receber alertas quando atos normativos sobre temas de meu interesse são publicados?',
                    answer:[`Para receber alertas, é preciso estar logado com o seu e-mail e salvar palavras-chave. Para isso, você vai precisar clicar na estrela.`,
                    `image11.png`,
                    `Em seguida, você deve clicar em “criar alerta para palavras-chave” no canto direito superior da tela, digitar a palavra-chave, criar um nome para o seu alerta e cadastrar. A partir desse momento, você receberá no seu e-mail uma notificação quando algum ato normativo for publicado com a sua palavra-chave.`,
                    `image12.png`],
                    open:false,
                },
                {
                    question:'Como buscar os atos normativos por tipo?',
                    answer:[`É possível selecionar os tipos de atos normativos que quer encontrar na sua busca. Você pode selecionar três, dois ou apenas um tipo de ato normativo. Ou seja, você pode procurar apenas por decretos, apenas por portarias ou apenas por instruções normativas. Basta selecionar os check-boxes.`,
                    `image13.png`],
                    open:false,
                },
                {
                    question:'Eu preciso me cadastrar na plataforma para usá-la?',
                    answer:[`Não é necessário cadastro para acessar a plataforma Atos. A única funcionalidade que necessita de cadastro é o Alerta: cada usuário escolhe para quais palavras-chave deseja receber alertas, que são enviados para o email registrado.`],
                    open:false,
                },
                {
                    question:'Quais informações são necessárias para o cadastro na plataforma?',
                    answer:[`Para realizar o cadastro, o usuário precisa inserir seu nome, email e cadastrar uma senha de acesso. `],
                    open:false,
                },
                {
                    question:'Esqueci minha senha, como posso recuperá-la?',
                    answer:[`Caso você deseje recuperar sua senha, basta clicar no link “Login”. Na janela que será aberta, clique em “Esqueci minha senha”. Digite seu email e depois em “Enviar”. Aparecerá a mensagem “E-mail enviado com sucesso”. Será enviado para o email digitado um link para troca da senha. Ao clicar no link do email, será aberta uma nova página solicitando uma nova senha. Digite a nova senha e clique em “Salvar”.Volte para a plataforma e faça login com seu email e a nova senha.`],
                    open:false,
                },
                {
                    question:'Como posso apoiar o desenvolvimento do ATOS?',
                    answer:[`Seu retorno sobre as funcionalidades e a experiência de uso da plataforma é fundamental para que possamos aperfeiçoá-la, disponibilizando uma plataforma que apoie cada vez mais o acompanhamento das mudanças realizadas por atos normativos pelos diferentes setores da sociedade. Em caso de dúvidas, sugestões e alertas de erro, por favor envie-nos uma mensagem por meio de nosso contato.`],
                    open:false,
                },
                {
                    question:'Consigo visualizar todas as modificações realizadas nos decretos?',
                    answer:[`Nossa equipe vem trabalhando para identificar todos os padrões de texto das publicações para identificar essas modificações. Nessa versão beta, as alterações realizadas nos anexos dos decretos ainda não aparecem disponíveis. Eventuais mudanças de padrões na publicação ou no intervalo de publicação dos links dos decretos no site do Planalto também exigem um tempo maior de processamento.`],
                    open:false,
                },
                 
                // {
                //     question:'Eu preciso me cadastrar na plataforma para usá-la?',
                //     answer:`Não é necessário cadastro para acessar a plataforma Atos. A única funcionalidade que necessita de cadastro é o Alerta: cada usuário escolhe para quais palavras-chave deseja receber alertas, que são enviados para o email registrado. `,
                //     open:false,
                // },
                // {
                //     question:'Quais informações são necessárias para o cadastro na plataforma?',
                //     answer:`Para realizar o cadastro, o usuário precisa inserir seu nome, email e cadastrar uma senha de acesso. `,
                //     open:false,
                // },
                // {
                //     question:'Esqueci minha senha, como posso recuperá-la?',
                //     answer:`Caso você deseje recuperar sua senha, basta clicar no link “Login”. Na janela que será aberta, clique em “Esqueci minha senha”. Digite seu email e depois em “Enviar”. Aparecerá a mensagem “E-mail enviado com sucesso”.
                //             Será enviado para o email digitado um link para troca da senha. Ao clicar no link do email, será aberto uma nova página solicitando uma nova senha. Digite a nova senha e clique em “Salvar”.Volte para a plataforma e faça login com seu email e a nova senha.`,
                //     open:false,
                // },
                      
            ]
        }
    }

}
</script>

<style>

</style>